import React, { useContext } from "react";
import GlobalContext from "../../../context/global";
import { useStore } from "zustand";
import { useVehicleOfInterestStore } from "../../../../stores";
import { leadsService, VehicleOfInterestService } from "../../../../services";
import VehicleTypeSwitcherLink from "./VehicleTypeSwitcherLink";
import { ToggleSwitch } from "../index";
import classNames from "classnames";

const vehicleOfInterestService = new VehicleOfInterestService();

const VehicleTypeSwitcherSection = ({ divider = true }) => {
  const appData = useContext(GlobalContext);
  const { currentYear, isCDTT } = appData;
  const vehicleOfInterest = useStore(useVehicleOfInterestStore);

  const switchOptions = {
    showNew: vehicleOfInterestService.presentedOptionIs("new"),
    showUsed: vehicleOfInterestService.presentedOptionIs("used"),
  };

  if (isCDTT) {
    switchOptions.showNewAndUsed =
      vehicleOfInterestService.presentedOptionIs("new_and_used");
  }

  const switchVehicleState = () => {
    if (vehicleOfInterest.vehicleState === "new") {
      vehicleOfInterestService.set({ vehicleState: "used" });
    }

    if (vehicleOfInterest.vehicleState === "used") {
      vehicleOfInterestService.set({ vehicleState: "new" });
      vehicleOfInterestService.setSelected({ year: currentYear });
      vehicleOfInterestService.getNewMakes(currentYear);
      leadsService.set({
        vehicleOfInterest: {
          ...leadsService.get("vehicleOfInterest"),
          year: currentYear,
        },
      });
    }
  };

  return (
    <>
      <div className="row">
        {divider && (
          <span className="col">
            <hr className="border-top border-dark border-1 mt-3" />
          </span>
        )}
        <p className="text-center">
          What is the vehicle you have in mind for your next lease or purchase?
        </p>
      </div>
      {switchOptions.showNew && switchOptions.showUsed && (
        <div className="row d-flex justify-content-center">
          <div className="col-4 text-end align-middle">
            <VehicleTypeSwitcherLink
              targetState="new"
              currentState={vehicleOfInterest.vehicleState}
              switchVehicleState={switchVehicleState}
            />
          </div>
          <div className="col-2 p-0 d-flex align-items-center justify-content-center">
            <ToggleSwitch
              checked={vehicleOfInterest.vehicleState === "used"}
              onChange={switchVehicleState}
            />
          </div>
          <div className="col-4 align-middle pt-1 fs-14p fw-bold">
            <VehicleTypeSwitcherLink
              targetState="used"
              currentState={vehicleOfInterest.vehicleState}
              switchVehicleState={switchVehicleState}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default VehicleTypeSwitcherSection;
